import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useSocket } from './SocketContext';

const FiatMarketContext = createContext();

export function FiatMarketProvider({ children }) {
    const { isConnected, joinChannel, leaveChannel, requestMarketData, on, off } = useSocket();

    const [stocks, setStocks] = useState([]);
    const [forex, setForex] = useState([]);
    const [commodities, setCommodities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [dataSource, setDataSource] = useState('');

    // Join market channel and listen for data
    useEffect(() => {
        if (!isConnected) {
            console.log('⏳ Socket bağlantısı bekleniyor (market)...');
            return;
        }

        console.log('📺 Market kanalına katılınıyor...');
        joinChannel('market');
        setDataSource('TCMB');

        // Handle market data
        const handleMarketData = (data) => {
            console.log('📊 Market data alındı:', data);
            setForex(data.forex || []);
            setStocks(data.stocks || []);
            setCommodities(data.commodities || []);
            setLastUpdate(new Date());
            setLoading(false);
            setError(null);
        };

        on('market:data', handleMarketData);

        return () => {
            console.log('📺 Market kanalından ayrılınıyor...');
            off('market:data', handleMarketData);
            leaveChannel('market');
        };
    }, [isConnected, joinChannel, leaveChannel, on, off]);

    // Manual refresh
    const refresh = useCallback(() => {
        if (isConnected) {
            console.log('🔄 Manuel yenileme istendi');
            requestMarketData();
            return Promise.resolve();
        }
        return Promise.reject(new Error('Socket bağlı değil'));
    }, [isConnected, requestMarketData]);

    const value = {
        stocks,
        forex,
        commodities,
        loading,
        error,
        lastUpdate,
        connected: isConnected,
        dataSource,
        refresh,
    };

    return (
        <FiatMarketContext.Provider value={value}>
            {children}
        </FiatMarketContext.Provider>
    );
}

export function useFiatMarket() {
    const context = useContext(FiatMarketContext);
    if (!context) {
        throw new Error('useFiatMarket must be used within a FiatMarketProvider');
    }
    return context;
}

export default FiatMarketContext;
